import {
    ListingSummaryDetailsFragment,
    ProcessedAttributesReturnType
} from 'listing-details/components/ListingSummaryDetails/ListingSummaryDetails.types';
import { LISTING_SUMMARY_CONSTANTS } from '.';
import { numberFormatter } from '../../../../shared/helpers';

export const getAttributes = ({
    floorArea,
    counts
}: ListingSummaryDetailsFragment): ProcessedAttributesReturnType => {
    const attributeStrings = LISTING_SUMMARY_CONSTANTS.summaryAttributes;
    let floorAreaLabelValue = '';
    let numBedroomsValue = '';
    let numBathroomsValue = '';
    let numLivingRoomsValue = '';

    if (floorArea && floorArea.value && floorArea.unitsLabel) {
        floorAreaLabelValue = `${numberFormatter.format(floorArea.value)} ${
            floorArea.unitsLabel
        }`;
    }

    if (counts) {
        if (counts.numBedrooms) {
            numBedroomsValue = `${counts.numBedrooms} ${
                counts.numBedrooms === 1
                    ? attributeStrings.bedTextSingular
                    : attributeStrings.bedTextPlural
            }`;
        }

        if (counts.numBathrooms) {
            numBathroomsValue = `${counts.numBathrooms} ${
                counts.numBathrooms === 1
                    ? attributeStrings.bathTextSingular
                    : attributeStrings.bathTextPlural
            }`;
        }

        if (counts.numLivingRooms) {
            numLivingRoomsValue = `${counts.numLivingRooms} ${
                counts.numLivingRooms === 1
                    ? attributeStrings.livingTextSingular
                    : attributeStrings.livingTextPlural
            }`;
        }
    }

    return {
        floorAreaLabel: floorAreaLabelValue,
        numBedrooms: numBedroomsValue,
        numBathrooms: numBathroomsValue,
        numLivingRooms: numLivingRoomsValue
    };
};
